import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Autoklice from "@/components/site/Autoklice";
import ONas from "@/components/site/ONas";
import Reviews from "@/components/site/Reviews";
import Fotopas from "@/components/site/Fotopas";
import Kontakt from "@/components/site/Kontakt";
import Footer from "@/components/site/Footer";
import SectionDivider from "@/components/site/SectionDivider";

const NAVY = "#093a5a";
const WHITE = "#ffffff";
const SLATE = "#f8fafc";
const ORANGE = "#f97316";

export default function Home({ onNav }) {
  return (
    <>
      <main>
        <Hero onNav={onNav} />
        <SectionDivider to={WHITE} accent={ORANGE} />

        <Services />
        <SectionDivider from={WHITE} to={NAVY} accent={ORANGE} flip />

        <Autoklice />
        <SectionDivider from={NAVY} to={WHITE} accent={ORANGE} />

        <ONas />
        <SectionDivider from={WHITE} to={SLATE} accent={ORANGE} flip />

        <Reviews />

        <Fotopas />

        <Kontakt />
      </main>

      <Footer onNav={onNav} />
    </>
  );
}
